const collections = [
  { title: '动作大片合集', desc: '热血激战、枪战追逐、极限冒险，肾上腺素飙升的观影体验', icon: 'ri-fire-line', count: '326部' },
  { title: '喜剧精选', desc: '爆笑喜剧、温情小品、黑色幽默，让你笑到停不下来', icon: 'ri-emotion-happy-line', count: '418部' },
  { title: '悬疑烧脑', desc: '高智商犯罪、心理惊悚、反转神作，挑战你的推理极限', icon: 'ri-lightbulb-flash-line', count: '257部' },
  { title: '经典重温', desc: '豆瓣高分经典、影史必看、那些年错过的神作', icon: 'ri-vip-crown-line', count: '189部' },
  { title: '新片速递', desc: '院线新片、流媒体首发，第一时间追更最新影视', icon: 'ri-rocket-line', count: '每日更新' },
  { title: '华语佳片', desc: '国产高分、港片经典、台剧精选，华语影视宝藏', icon: 'ri-china-railway-line', count: '502部' },
  { title: '动漫番剧', desc: '热血番、治愈系、剧场版，二次元世界一网打尽', icon: 'ri-ghost-line', count: '643部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-4 whitespace-nowrap">
            专题索引
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            影视专题合集
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按类型、题材、热度分类整理，帮你快速找到想看的免费电影和在线视频
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {collections.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200/80 border border-background-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-primary-500 text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {item.count}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}